import { Box, CircularProgress, Typography } from '@mui/material';
import * as React from 'react';
import { SearchEventList } from '../components/SearchEventList';
import { SearchHeader } from '../components/SearchHeader';
import { useSearchEvents } from '../hooks/useSearchEvents';

export const SearchPage: React.FC = () => {
  const eventUIds = localStorage.getItem('keyValueUi') || '';
  const { events, loading, error } = useSearchEvents(eventUIds);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background:
          'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important',
        pt: { xs: 12, md: 12 },
        pb: { xs: 4, md: 6 },
        px: { xs: 2, md: 3 },
      }}
    >
      <SearchHeader />
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {error && (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {error}
        </Typography>
      )}
      {!loading && !error && <SearchEventList events={events} />}
    </Box>
  );
};

export default SearchPage;
